export default __webpack_public_path__ + "media/images/images_v2/btn-import-7ab1ac8b1feec93f305aca16ef82f04c.png";